import React, { useEffect } from "react";
import { Route } from "react-router-dom";

import { useProfile } from "app/context";
import { canViewSkillsField } from "app/permissions";
import { seo, t } from "app/utils";

import Person from "components/Person";
import SlackIntegration from "components/admin/integrations/SlackIntegration";
import ProfileStatus from "./profile/Status";

const Profile = () => {
  const { profile } = useProfile();
  const { organization } = profile;
  const { isEducational } = organization;

  useEffect(
    () => {
      seo({
        title: `${t("My Profile")} - CultureHQ.com`
      });
    },
    []
  );

  // Ensure that profile has loaded before initializing routes
  if (!profile || !profile.id) {
    return null;
  }

  return (
    <div className="Profile col-sm-12">
      <div className="row">
        <Route
          exact
          path="/profile/integrations"
          render={() => (
            <div className="Profile__Content box-shadow">
              <SlackIntegration />
            </div>
          )}
        />
        <Route
          exact
          path="/profile/status"
          render={() => (
            <div className="Profile__Content box-shadow">
              <ProfileStatus />
            </div>
          )}
        />
        <Route exact path="/profile/achievements/:page?" component={Person} />
        <Route exact path="/profile/activity/recognitions/:page?" component={Person} />
        <Route exact path="/profile/activity/posts" component={Person} />
        <Route exact path="/profile/activity/events/:page?" component={Person} />
        <Route exact path="/profile/community/following" component={Person} />
        <Route exact path="/profile/community/followers" component={Person} />
        <Route exact path="/profile/settings/emails" component={Person} />
        <Route exact path="/profile/settings/interests" component={Person} />
        <Route exact path="/profile/settings/password" component={Person} />
        {!isEducational && canViewSkillsField(organization) && (<Route exact path="/profile/settings/skills" component={Person} />)}
        {isEducational && (<Route exact path="/profile/settings/clubs" component={Person} />)}
        <Route exact path="/profile/settings/social" component={Person} />
        <Route exact path="/profile/settings" component={Person} />
        <Route exact path="/profile" component={Person} />
        <Route exact path="/profile/new/stories/create" component={Person} />
        <Route exact path="/profile/new/stories/:id" component={Person} />
      </div>
    </div>
  );
};

export default Profile;
